import { GzFirewallNetworkWebComponent } from './component/GzFirewallNetworkWebComponent';

export { GzFirewallNetworkWebComponent };
